"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vertex_1 = require("../../base/vertex");
class ImageVertex extends vertex_1.Vertex {
    setImageLink(link) {
        this.link = link;
    }
    getImageLink() {
        return this.link;
    }
}
exports.ImageVertex = ImageVertex;
